import { ISnookerTable } from "../../types/ISnookerTable";

export function totalDuration(st: ISnookerTable) {
  let timeDiff = new Date().getTime() - new Date(st.startTime).getTime();

  timeDiff = timeDiff / 1000;
  let seconds = Math.floor(timeDiff % 60);
  let secondsAsString = seconds < 10 ? "0" + seconds : seconds;

  timeDiff = Math.floor(timeDiff / 60);
  let minutes = timeDiff % 60;
  let minutesAsString = minutes < 10 ? "0" + minutes : minutes;

  timeDiff = Math.floor(timeDiff / 60);
  let hours = timeDiff % 24;

  return hours + ":" + minutesAsString + ":" + secondsAsString;
}

export function durationInMin(st: ISnookerTable) {
  let timeDiff = new Date().getTime() - new Date(st.startTime).getTime();

  timeDiff = timeDiff / 1000;
  let seconds = Math.floor(timeDiff % 60);
  let secondsAsString = seconds < 10 ? "0" + seconds : seconds;

  timeDiff = Math.floor(timeDiff / 60);
  let minutes = timeDiff % 60;
  let minutesAsString = minutes < 10 ? "0" + minutes : minutes;

  timeDiff = Math.floor(timeDiff / 60);
  let hours = timeDiff % 24;

  return minutes;
}

export function durationInhours(st: ISnookerTable) {
  let timeDiff = new Date().getTime() - new Date(st.startTime).getTime();

  timeDiff = timeDiff / 1000;
  let seconds = Math.floor(timeDiff % 60);
  let secondsAsString = seconds < 10 ? "0" + seconds : seconds;

  timeDiff = Math.floor(timeDiff / 60);
  let minutes = timeDiff % 60;
  let minutesAsString = minutes < 10 ? "0" + minutes : minutes;

  timeDiff = Math.floor(timeDiff / 60);
  let hours = timeDiff % 24;

  return hours;
}

export function totalSnookerTable(table: ISnookerTable) {
  let total = 0;
  const minPlayed = durationInMin(table);
  const hrsPlayed = durationInhours(table);
  const hirePricePerMin = (table.peekPrice * 100) / 60;

  if (hrsPlayed === 0) {
    return table.peekPrice;
  }

  total = hrsPlayed * (table.peekPrice * 100);

  //extra min they played over the hour(s)

  const totalPricePerMinPlayed = minPlayed * hirePricePerMin;
  total = total + totalPricePerMinPlayed;

  return (total / 100).toFixed(2);
}

export function totalHireTable(table: ISnookerTable) {
  let total = 0;
  const minPlayed = durationInMin(table);
  const hrsPlayed = durationInhours(table);
  const hirePricePerMin = (table.peekPrice * 100) / 60;

  if (hrsPlayed === 0) {
    return table.peekPrice;
  }

  total = hrsPlayed * (table.peekPrice * 100);

  //extra min they played over the hour(s)

  const totalPricePerMinPlayed = minPlayed * hirePricePerMin;
  total = total + totalPricePerMinPlayed;

  return total / 100;
}

export function formatDateTime(dt: Date) {
  const date = new Date(dt);
  var year = date.getFullYear(),
    month = date.getMonth() + 1, // months are zero indexed
    day = date.getDate(),
    hour = date.getHours(),
    minute = date.getMinutes(),
    second = date.getSeconds(),
    hourFormatted = hour % 12 || 12, // hour returned in 24 hour format
    minuteFormatted = minute < 10 ? "0" + minute : minute,
    morning = hour < 12 ? "am" : "pm";

  return day + "/" + month + "/" + year + " " + hour + ":" + minute;
}

//work out time remaining here

export function addMinutes(date: Date, minutes: number) {
  var copiedDate = new Date(date.getTime());
  return new Date(copiedDate.getTime() + minutes * 60000);
}

export function remainingTime(table: ISnookerTable) {
  if (table.reminderInMinutes === -1) {
    return <></>;
  }

  const start = new Date(table.startTime);
  let end = addMinutes(start, table.reminderInMinutes);

  let timeDiff = end.getTime() - new Date().getTime();

  timeDiff = timeDiff / 1000;
  let seconds = Math.floor(timeDiff % 60);
  let secondsAsString = seconds < 10 ? "0" + seconds : seconds;

  timeDiff = Math.floor(timeDiff / 60);
  let minutes = timeDiff % 60;
  let minutesAsString = minutes < 10 ? "0" + minutes : minutes;

  timeDiff = Math.floor(timeDiff / 60);
  let hours = timeDiff % 24;

  if (hours < 0 && minutes < 0 && seconds < 0) {
    return "00:00:00";
  }

  return hours + ":" + minutesAsString + ":" + secondsAsString;
}

export function reminderInSeconds(table: ISnookerTable) {
  if (table.reminderInMinutes === -1) {
    return -999;
  }
  const start = new Date(table.startTime);
  let end = addMinutes(start, table.reminderInMinutes);

  var msec = end.getTime() - new Date().getTime();
  var ss = Math.floor(msec / 1000);

  return ss;
}
